import NProgress from 'nprogress'
import io from 'socket.io-client'

window.onload = () => {
	let div = document.createElement('div');
	div.innerHTML =
		`<link rel="shortcut icon" href="https://en.idcgames.com/favicon.ico">		
		<link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.10.0/styles/default.min.css">
		`;

    document.head.append(...div.children);
}

import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'

import axios from 'axios'
import VueAxios from 'vue-axios'

import linkExpander from './assets/js/linkExpander'

import App from './App'
import store from './store/index'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueCookies from 'vue-cookies'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBell, faComment } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faTwitter, faInstagram, faPinterestP, faYoutube, faTwitch, faVk, faTiktok, faDiscord, faGoogle, faFacebookSquare, faSteamSymbol, faYahoo, faMicrosoft } from '@fortawesome/free-brands-svg-icons'
import {
	faBars, faPlus, faEdit, faGrin, faLink, faCode,
	faTimes, faUnlockAlt, faReply, faHome, faTh,
	faExclamationCircle, faUserCircle, faThumbsUp,
	faComments, faUser, faCog, faLock, faCloudUploadAlt,
	faSearch, faChevronDown, faSortAmountUp, faSortAmountDown,
	faCheck, faCross, faQuoteRight, faMinus, faCaretUp, faCaretDown, faChevronRight, 
	faHeart, faMailBulk, faShareAlt, faFlag, faGrinAlt, faBold, faItalic, faSignOutAlt , faSignInAlt, faUserAstronaut
} from '@fortawesome/free-solid-svg-icons'

library.add(
	faBars, faEdit, faPlus, faGrin, faLink, faCode,
	faTimes, faBell, faUnlockAlt, faReply, faHome,
	faTh, faExclamationCircle, faUserCircle, faThumbsUp,
	faComments, faUser, faCog, faLock, faCloudUploadAlt,
	faSearch, faChevronDown, faSortAmountUp, faSortAmountDown, faChevronRight,
	faComment, faCheck, faCross, faQuoteRight, faMinus, faCaretUp, faCaretDown, faMicrosoft,
	faHeart, faMailBulk, faFacebook, faTwitter, faInstagram, faPinterestP, faYoutube, faTwitch, faVk, faTiktok, faDiscord, faGoogle, faFacebookSquare, faSteamSymbol, faYahoo,
	faShareAlt, faFlag, faGrinAlt, faBold, faItalic, faSignOutAlt, faSignInAlt, faUserAstronaut
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const Landing = () => import('./components/routes/Landing')
const Profile = () => import('./components/routes/Profile')
const MyAdminDashboard = () => import('./components/routes/MyAdminDashboard')

const GameContainer = () => import('./components/routes/GameContainer')
const Index = () => import('./components/routes/Index')
const P = () => import('./components/routes/P')
// const Start = () => import('./components/routes/Start')
const Thread = () => import('./components/routes/Thread')
const ThreadNew = () => import('./components/routes/ThreadNew')

const Search = () => import('./components/routes/Search')
const SearchUsersThreads = () => import('./components/routes/SearchUsersThreads')

const User = () => import('./components/routes/User')
const UserPosts = () => import('./components/routes/UserPosts')
const UserThreads = () => import('./components/routes/UserThreads')

const Settings = () => import('./components/routes/Settings')
const SettingsGeneral = () => import('./components/routes/SettingsGeneral')
const SettingsAccount = () => import('./components/routes/SettingsAccount')

const Admin = () => import('./components/routes/Admin')
const AdminDashboard = () => import('./components/routes/AdminDashboard')
const AdminModerationReports = () => import('./components/routes/AdminModerationReports')
const AdminModerationBannedUsers = () => import('./components/routes/AdminModerationBannedUsers')
const AdminGeneral = () => import('./components/routes/AdminGeneral')
const AdminUsers = () => import('./components/routes/AdminUsers')

Vue.prototype.$mMultiLangs = ["ar","bs","cs","da","de","el","en","es","fi","fr","hr","it","ja","ko","nl","no","pl","pt","ro","ru","sr","sv","th","tr","uk","vi","zh"];

import NotFound from './components/routes/NotFound'

const { CATEGORY_ALL } = require('../../lib/const')

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueI18n)
Vue.use(VueAxios, axios)
Vue.use(linkExpander)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueCookies)


Vue.use({
	install (Vue) {
		Vue.prototype.$socket = io();
	}
})

// init i18n
const messages = require('./assets/js/messages')
const i18n = new VueI18n({
  	locale: 'en',
  	fallbackLocale: 'es',
  	formatFallbackMessages: true,
  	messages
})

const router = new VueRouter({
	routes: [
		{ path: '/', redirect: '/en/landing', name: 'root'},
		{ path: '/:lang/landing', component: Landing, name: 'landing'},
		{ path: '/:lang/game/:gameseo', redirect: to => { return '/:lang/game/:gameseo/category/' + CATEGORY_ALL[to.params.lang]["url"]}, component: GameContainer, name: 'game/home', children: [
			{ path: 'category/:category', component: Index },
			{ path: 'p/:id', component: P },
			{ path: 'thread/:slug/:id', component: Thread },
			{ path: 'thread/:slug/:id/:post_number', name: 'thread-post', component: Thread },
			{ path: 'thread/new', component: ThreadNew },
			{ path: 'search/:q', component: Search },
			{ path: 'search/users/:q', component: SearchUsersThreads, name: 'search/users' },
			{ path: 'search/threads/:q', component: SearchUsersThreads, name: 'search/threads' },
			{ path: 'user/:username', redirect: '/:lang/game/:gameseo/user/:username/posts', component: User, children: [
				{ path: 'posts', component: UserPosts },
				{ path: 'threads', component: UserThreads }
			]},
			{ path: 'admin', redirect: '/:lang/game/:gameseo/admin/moderation/reports', component: Admin, children: [
				{ path: 'dashboard', component: AdminDashboard },
				{ path: 'general', component: AdminGeneral },
				{ path: 'users', component: AdminUsers },
				{ path: 'moderation', redirect: '/admin/moderation/reports' },
				{ path: 'moderation/reports', component: AdminModerationReports },
				{ path: 'moderation/bans', component: AdminModerationBannedUsers }
			] },
		] },
    	{ path: '/:lang/settings', redirect: '/:lang/settings/general', component: Settings, children: [
			{ path: 'general', component: SettingsGeneral, name: 'settings/general' },
			{ path: 'account', component: SettingsAccount, name: 'settings/account' }
		] },
		{ path: '/:lang/profile', component: Profile, name: 'profile' },
		{ path: '/:lang/admin_dashboard', component: MyAdminDashboard, name: 'admin_dashboard' },
    	{ path: '*', component: NotFound }
	],
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	//Init
	let cLang = to.fullPath.split("/")[1];
	router.app.$store.commit('setLang', cLang);

	i18n.locale = cLang;
	i18n.fallbackLocale = cLang;

	if(router.app.$store.state.gameID && !to.fullPath.split('/')[2] === 'game' && (
		!to.name || (to.name !== 'landing' && to.name !== 'start' && !to.name.split('/')[2]==='settings')
	)){
		NProgress.start()
		next(router.app.$store.state.lang + '/game/' + router.app.$store.state.gameID + to.fullPath)
		return
	}

	router.app.$store.commit('set404Page', false)

	const sPaths = to.fullPath.split("/")

	if(sPaths && sPaths.length >= 4 && sPaths[2] == "game" && decodeURI(sPaths[3])){
		if(!router.app.$store.state.gameID || router.app.$store.state.gameID != decodeURI(sPaths[3]) ){
			router.app.$store.commit('setGameID', decodeURI(sPaths[3]) )
			router.app.$store.dispatch('checkGameValidity', decodeURI(sPaths[3]) )
		}
	}else{
		router.app.$store.commit('setGameID', null)

		if(!to.name) {
			router.app.$store.commit('set404Page', true)
		}
	}

	//Do not change progress bar when scrolling through posts on a thread
	if(
		(to.name !== 'thread-post' && from.name !== 'thread-post') &&
		(!to.params.id || to.params.id !== from.params.id)
	) {
		NProgress.start()
	}

	next()
})

router.afterEach((to, from) => {

	NProgress.done()
})

axios.interceptors.request.use((config) => {

  const id_idcgame = (
    router.app.$store.state.meta.gamesDict &&
    router.app.$store.state.gameID &&
    router.app.$store.state.meta.gamesDict[router.app.$store.state.gameID] &&
    router.app.$store.state.meta.gamesDict[router.app.$store.state.gameID].id) || 0

  const lang = (router.app.$store.state.meta.lang || 'en')

  config.headers ? config.headers.gameid = id_idcgame : config.headers = { gameid: id_idcgame }
  config.headers ? config.headers.lang = lang : config.headers = { lang: lang }

  return config;
});


Vue.filter('formatDate', function (value) {
	if(typeof value !== 'object') {
		value = new Date(value)
	}


	let sinceNow = new Date(new Date() - value)

	//Add leading zero if under 10
	function lz(num) {
		if(num < 10) {
			return '0' + num;
		} else {
			return '' + num;
		}
	}

	function p(word, num) {
		if(num === 1) {
			return word
		} else {
			return word + 's'
		}
	}

	//2 minutes
	if(sinceNow <= 1000*60*2) {
		return 'Just now'
	} else if(sinceNow <= 1000*60*60) {
		return sinceNow.getMinutes()  + ' minutes ago'
	} else if(sinceNow <= 1000*60*60*24) {
		let hours = sinceNow.getHours()
		return hours + ' ' + p('hour', hours) + ' ago'
	} else if(sinceNow <= 1000*60*60*24*2) {
		let days = Math.floor(sinceNow / (1000*60*60*24))
		return days + ' ' + p('day', days) + ' ago at ' + value.toTimeString().slice(0, 5)
	} else {
		return (
			lz(value.getDate()) + '/' +
			lz(value.getMonth() + 1) + '/' +
			value.getUTCFullYear()
		);
	}
});

Vue.filter('stripTags', function (value) {
	let doc = new DOMParser().parseFromString(value, 'text/html')
	return doc.body.textContent || ''
});

Vue.filter('truncate', function (value, length) {
	if(value.length <= length) {
		return value
	} else {
		return value.slice(0, length) + '…'
	}
});
Vue.filter('truncateMid', function (value, length) {
	if(value.length <= length) {
		return value
	} else {
		let firstLen = Math.round(length/2);
		let secondLen = length - firstLen;

		return value.slice(0, firstLen) + '…' + value.slice(value.length-secondLen, value.length)
	}
});

Vue.filter('pluralize', function(number, value) {
	if(number === 1) {
		return value
	} else {
		return value + 's'
	}
})

let Root = new Vue({
  	i18n,
	store,
	router,
	render: h => h(App)
}).$mount('#app');

let cookieDict = document.cookie
	.split(';')
	.map(a => a.split('=').map(a => a.trim()) )
	.map(a => {
		let k = a[0], v = a[1]
		return { [k] : v }
	})
	.reduce((combinedObj, o) => {
		let key = Object.keys(o)[0]
		combinedObj[key] = o[key]

		return combinedObj
	}, {})

if(cookieDict.username) Root.$store.commit('setUsername', cookieDict.username)

if(cookieDict.admin === 'false') {
	Root.$store.commit('setAdmin', false)
} else if(cookieDict.admin === 'true') {
	Root.$store.commit('setAdmin', true)
}
